/**
 * Lansly AI 에이전트 백엔드 API 클라이언트
 * 프로덕션: 동일 출처 상대경로(/api/lansly/ai/...). 로컬: setupProxy 또는 REACT_APP_API_BASE.
 */
const API_BASE = process.env.REACT_APP_API_BASE || '';

/**
 * 대화 한 턴 전송 (SSE 스트리밍).
 * @param {string} projectId
 * @param {string} userId
 * @param {Array} messages
 * @param {(label:string)=>void} [onStatus] - 진행 단계 콜백
 * @returns {Promise<{message:string, stagedChanges:Array}>}
 */
export const aiChat = async (projectId, userId, messages, onStatus) => {
  const res = await fetch(`${API_BASE}/api/lansly/ai/chat`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ projectId, userId, messages }),
  });

  // SSE 시작 전 에러(검증 400 / 권한 403)는 JSON으로 옴
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || `요청 실패 (${res.status})`);
  }

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  let result = null;
  let errMsg = null;

  const handleEvent = (raw) => {
    const lines = raw.split('\n');
    let event = 'message';
    let dataStr = '';
    for (const line of lines) {
      if (line.startsWith('event:')) event = line.slice(6).trim();
      else if (line.startsWith('data:')) dataStr += line.slice(5).trim();
    }
    if (!dataStr) return;
    let data;
    try {
      data = JSON.parse(dataStr);
    } catch (e) {
      return;
    }
    if (event === 'status') onStatus?.(data.label);
    else if (event === 'done') result = data;
    else if (event === 'error') errMsg = data.error;
  };

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const blocks = buffer.split('\n\n');
    buffer = blocks.pop() || '';
    for (const b of blocks) if (b.trim()) handleEvent(b);
  }
  if (buffer.trim()) handleEvent(buffer);

  if (errMsg) throw new Error(errMsg);
  if (!result) throw new Error('AI 응답을 받지 못했습니다. 잠시 후 다시 시도해 주세요.');
  return result;
};

/** staged 변경 적용 → { applied } */
export const aiApply = async (projectId, userId, stagedChanges) => {
  const res = await fetch(`${API_BASE}/api/lansly/ai/apply`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ projectId, userId, stagedChanges }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `요청 실패 (${res.status})`);
  return data;
};

const aiAgentApi = { aiChat, aiApply };
export default aiAgentApi;
